import { SERVER_URL } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { AuthService } from './auth.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./auth.service";
export class NitsRepresentativeService {
    constructor(http, authService) {
        this.http = http;
        this.authService = authService;
    }
    /**
     * Nits by representative
     *
     * @author Santiago Osorio
     * @param {Object} questions - Get groups, nits and players by nit
     * @returns {Promise<String>} -
     *
   **/
    getGroupsPlayer(companyId, zone) {
        const url = SERVER_URL + '/api/crm/groups/?company_id=' + companyId + `&zones=` + zone;
        const headers = this.authService.getAuthHeaders();
        return this.http.get(url, headers).toPromise();
    }
    getListNits(nit, zone, anioMes, page = 0, size = 10) {
        page += 1;
        let url = SERVER_URL + '/api/crm/list_nits_by_rct/' + anioMes + '?nit=' + nit + `&page=` + page;
        if (zone !== '') {
            url = url + `&zone=` + zone;
        }
        const headers = this.authService.getAuthHeaders();
        return this.http.get(url, headers).toPromise();
    }
    getDetallesNits(nit, anioMes) {
        const url = SERVER_URL + '/api/crm/list_players_by_nit/' + anioMes + '?nit=' + nit;
        const headers = this.authService.getAuthHeaders();
        return this.http.get(url, headers).toPromise();
    }
}
NitsRepresentativeService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function NitsRepresentativeService_Factory() { return new NitsRepresentativeService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.AuthService)); }, token: NitsRepresentativeService, providedIn: "root" });
